module.exports = __webpack_public_path__ + "static/media/ardentarola1.66b073d0.jpeg";